import { FC } from "react";
import { useIntl } from "react-intl";

interface ValidOTPProps {}
const ValidSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="68"
    viewBox="0 0 58 68"
    fill="none"
  >
    <path
      d="M57.5093 10.5635C57.3664 10.3988 57.1914 10.265 56.9949 10.1703C56.7985 10.0757 56.5848 10.0222 56.3669 10.0131C56.2069 10.0131 40.3957 9.37313 30.0213 0.768333C29.7343 0.530526 29.3732 0.400391 29.0005 0.400391C28.6277 0.400391 28.2667 0.530526 27.9797 0.768333C17.6053 9.39553 1.80048 10.0131 1.63408 10.0131C1.41703 10.0206 1.20376 10.0721 1.00728 10.1646C0.810789 10.2571 0.635195 10.3887 0.491189 10.5513C0.347183 10.7138 0.23778 10.904 0.169646 11.1102C0.101512 11.3164 0.0760717 11.5344 0.0948764 11.7507C0.0948764 11.7507 1.57648 28.8515 2.20688 35.9299C2.84688 42.9027 3.99568 55.8723 28.3125 67.4467C28.5278 67.5478 28.7627 67.6002 29.0005 67.6002C29.2383 67.6002 29.4732 67.5478 29.6885 67.4467C54.0085 55.8723 55.1701 42.9027 55.7941 35.9299C56.4341 28.8515 57.9061 11.7507 57.9061 11.7507C57.9231 11.5363 57.8968 11.3207 57.8286 11.1167C57.7604 10.9127 57.6518 10.7246 57.5093 10.5635ZM52.6069 35.6611C52.0437 41.9299 51.0069 53.5395 29.0005 64.2371C6.99408 53.5395 5.96048 41.9299 5.39408 35.6611C4.88208 29.9011 3.79408 17.5491 3.42288 13.1139C12.6015 12.4196 21.4298 9.29389 29.0005 4.05793C36.5711 9.29389 45.3994 12.4196 54.5781 13.1139C54.1941 17.5491 53.1189 29.9107 52.6069 35.6611ZM26.7221 37.0851L34.8661 27.3603C35.1385 27.0344 35.5292 26.8301 35.9523 26.7923C36.3754 26.7545 36.7962 26.8863 37.1221 27.1587C37.448 27.4312 37.6523 27.8219 37.6901 28.245C37.7279 28.6681 37.5961 29.0888 37.3237 29.4147L27.8997 40.6627C27.7496 40.8429 27.5617 40.9879 27.3494 41.0875C27.137 41.187 26.9054 41.2386 26.6709 41.2387H26.6421C26.4026 41.2338 26.1673 41.1752 25.9535 41.0672C25.7397 40.9592 25.5529 40.8046 25.4069 40.6147L20.6421 34.4387C20.5057 34.2733 20.404 34.0822 20.343 33.8767C20.282 33.6712 20.2628 33.4555 20.2868 33.2425C20.3107 33.0294 20.3772 32.8234 20.4823 32.6366C20.5875 32.4497 20.729 32.2859 20.8987 32.1549C21.0683 32.0239 21.2626 31.9282 21.4699 31.8737C21.6772 31.8192 21.8934 31.8069 22.1056 31.8376C22.3177 31.8682 22.5216 31.9412 22.705 32.0522C22.8884 32.1631 23.0477 32.3098 23.1733 32.4835L26.7221 37.0851Z"
      fill="#479821"
    />
  </svg>
);
const ValidOTP: FC<ValidOTPProps> = ({}) => {
  const intl = useIntl();
  return (
    <div className="space-y-[6]">
      <div className="flex justify-center">{ValidSVG}</div>
      <div>
        <h2 className="text-main-title text-2xl text-center">
          {intl.formatMessage({ id: "urEmailActivated" })}
        </h2>
      </div>
    </div>
  );
};

export default ValidOTP;
